interface CacheEntry {
  data: any[]
  timestamp: number
}

const cache = new Map<string, CacheEntry>()
const STALE_TIME = 5 * 60 * 1000 // 5 minutes

export function getCached(key: string): any[] | null {
  const entry = cache.get(key)
  if (!entry) return null
  if (Date.now() - entry.timestamp > STALE_TIME) {
    cache.delete(key)
    return null
  }
  return entry.data
}

export function setCache(key: string, data: any[]): void {
  cache.set(key, { data, timestamp: Date.now() })
}

export function invalidateCache(key?: string): void {
  if (key) {
    cache.delete(key)
  } else {
    cache.clear()
  }
}
